import React from "react";

const MentorsTechnicalSkills = ({ mentor }) => {
  return (
    <div className="p-[20px]">
      <div>
        <h4 className="text-lg font-semibold mb-2">Technical Skills</h4>
        <div className="flex flex-wrap gap-2">
          {mentor?.selectedSkills?.map((skill, index) => (
            <div
              key={index}
              className="border border-gray-300 px-4 py-1 rounded-full"
            >
              {skill}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MentorsTechnicalSkills;
